import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// salary_structures — โครงสร้างเงินเดือน (Salary Structure)
// ============================================================================
export const salaryStructures = sqliteTable("hr_salary_structures", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  isActive: integer("is_active").notNull().default(1),
  description: text("description"),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  ss_company_idx: index("ss_company_idx").on(table.companyId, table.isActive),
}));

// Type exports
export type SalaryStructure = typeof salaryStructures.$inferSelect;
export type NewSalaryStructure = typeof salaryStructures.$inferInsert;
